/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscountScope } from './DiscountScope';
import {
    DiscountScopeFromJSON,
    DiscountScopeFromJSONTyped,
    DiscountScopeToJSON,
    DiscountScopeToJSONTyped,
} from './DiscountScope';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';

/**
 * 
 * @export
 * @interface TuitionDiscountLine
 */
export interface TuitionDiscountLine {
    /**
     * 
     * @type {string}
     * @memberof TuitionDiscountLine
     */
    discountId?: string;
    /**
     * 
     * @type {DiscountScope}
     * @memberof TuitionDiscountLine
     */
    scope?: DiscountScope;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof TuitionDiscountLine
     */
    classId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof TuitionDiscountLine
     */
    locationId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {number}
     * @memberof TuitionDiscountLine
     */
    baseAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof TuitionDiscountLine
     */
    discountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof TuitionDiscountLine
     */
    discountedAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof TuitionDiscountLine
     */
    description?: string | null;
}



/**
 * Check if a given object implements the TuitionDiscountLine interface.
 */
export function instanceOfTuitionDiscountLine(value: object): value is TuitionDiscountLine {
    return true;
}

export function TuitionDiscountLineFromJSON(json: any): TuitionDiscountLine {
    return TuitionDiscountLineFromJSONTyped(json, false);
}

export function TuitionDiscountLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuitionDiscountLine {
    if (json == null) {
        return json;
    }
    return {
        
        'discountId': json['discountId'] == null ? undefined : json['discountId'],
        'scope': json['scope'] == null ? undefined : DiscountScopeFromJSON(json['scope']),
        'classId': json['classId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['classId']),
        'locationId': json['locationId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'baseAmount': json['baseAmount'] == null ? undefined : json['baseAmount'],
        'discountAmount': json['discountAmount'] == null ? undefined : json['discountAmount'],
        'discountedAmount': json['discountedAmount'] == null ? undefined : json['discountedAmount'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function TuitionDiscountLineToJSON(json: any): TuitionDiscountLine {
    return TuitionDiscountLineToJSONTyped(json, false);
}

export function TuitionDiscountLineToJSONTyped(value?: TuitionDiscountLine | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discountId': value['discountId'],
        'scope': DiscountScopeToJSON(value['scope']),
        'classId': ActorActivityRecordActorUserIdToJSON(value['classId']),
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'baseAmount': value['baseAmount'],
        'discountAmount': value['discountAmount'],
        'discountedAmount': value['discountedAmount'],
        'description': value['description'],
    };
}

